import { gql } from '@apollo/client';
import minimalLeadFragment from '../fragments/minimalLeadFragment';

export default gql`
  mutation createLead($input: LeadInput!, $executiveLeadInput: ExecutiveLeadInput) {
    createLead(input: $input, executiveLeadInput: $executiveLeadInput) {
      ...minimalLeadFragment
      client
    }
  }
  ${minimalLeadFragment}
`;
